import { Component, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../environments/environments';
import { CustomDomainResponse } from '../../models/responses/custom-domain-response';
import { CustomDomainService } from '../../services/custom-domain.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';
import { CustomDomainStatusResponse } from '../../models/responses/custom-domain-status';
import { MatSnackBar } from '@angular/material/snack-bar';
import { handleErrors } from '../../utilities/error-handler-utils';

@Component({
  selector: 'app-custom-domain',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatProgressSpinnerModule,
    NgIf
  ],
  templateUrl: './custom-domain.component.html',
  styleUrl: './custom-domain.component.scss'
})
export class CustomDomainComponent {
  frontEndHost = environment.fronEndUrl;
  frontEndIp = environment.frontEndIp;
  customDomainStatus?: CustomDomainStatusResponse
  customDomainForm!:FormGroup
  customDomain?: CustomDomainResponse
  isLoading = false;
  errorMessage: string | undefined = undefined;
  readonly panelOpenState = signal(false);
  constructor(
    private formBuilder:FormBuilder,
    private customDomainService: CustomDomainService,
    private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.fetchCustomDomain()
    this.fetchCustomDomainStatus()
    this.setUpForm();
  }

  createDomain(){

    if(this.customDomainForm.valid){
      this.isLoading = true;
      const domainName = this.customDomainForm.value['domainName'];

      this.customDomainService.createDomain(domainName).subscribe({
        next: (data)=>{

          this.customDomain =data;
          this.isLoading = false;
        },
        error:(error)=>{
          this.errorMessage = handleErrors(error);
          this.isLoading = false;
        }
      })
    }
  }


  deleteDomain() {
    this.isLoading = true;

    this.customDomainService.delete(this.customDomain!.id).subscribe({
      next: () => {
        this.customDomain = undefined;
        this.customDomainStatus = undefined
        this.isLoading = false;
        this.snackBar.open('Domain removed successfully', 'Close', { duration: 5000 });
      },
      error: (error) => {
        this.errorMessage = handleErrors(error);
        this.isLoading = false;
      }
    })
  }

  fetchCustomDomainStatus() {
    this.isLoading = true;
    this.customDomainService.fetchDomainStatusForLoggedUser().subscribe({
      next: (data) => {
        this.customDomainStatus = data
        this.isLoading = false;
      },
      error: (error) => {
        this.errorMessage = handleErrors(error);
        this.isLoading = false;
      }
    })
  }

  private fetchCustomDomain() {
    this.isLoading = true;
    this.customDomainService.fetchForLoggedUser().subscribe({
      next: (data) => {
        this.customDomain = data
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    })
  }
  
  private setUpForm(){
    this.customDomainForm  = this.formBuilder.group({
      domainName: [this.customDomain ?this.customDomain.domainName :'']
    })
  }

}
